import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { MIDDLE_MARGIN, LARGE_MARGIN, SMALL_MARGIN, SUBMIDDLE_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: SMALL_MARGIN,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: MIDDLE_MARGIN,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        '&:first-child': {
          marginTop: 76,
        },
      },
      heading: {
        marginBottom: SUBMIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: MIDDLE_MARGIN,
        },
      },
    }),
  );
export default useStyles;
